<ngx-ui-loader></ngx-ui-loader>
<div class="div-appointment-form" style="height: 700px;" data-automation-attribute="div-appointment-form">
  <div class="modalHeaderBlack height35">
    <mat-grid-list cols="12" class="width100 mg-0" rowHeight="45px">
      <mat-grid-tile [colspan]="2" [rowspan]="1" class="header-grid-tile">
        <span class="modal-title" style="font-size: 12px;font-weight: 500;">{{ "AppointmentPage.bookAppointment" | translate }}</span>
      </mat-grid-tile>
      <mat-grid-tile [colspan]="3" [rowspan]="1" class="grid-test-2">
        <mat-radio-group *ngIf="!isReschedule" [(ngModel)]="patientType" (change)="patientTypeChange($event)"
          class="radio-color" name="patientType" data-automation-attribute="radiogrp-patient-type">
          <mat-radio-button [value]="'new'" data-automation-attribute="radio-new">{{ "AppointmentPage.new" | translate
            }}</mat-radio-button>
          <mat-radio-button [value]="'registered'" data-automation-attribute="radio-existing">{{
            "AppointmentPage.existing" | translate }}
          </mat-radio-button>
        </mat-radio-group>
      </mat-grid-tile>
      <mat-grid-tile [colspan]="5" [rowspan]="1" class="grid-test-1">
        <div class="master-search" *ngIf="patientType=='registered'">
          <mat-icon matTooltip="{{ 'RegistrationPage.searchBar' | translate }}">search</mat-icon>
          <input type="text" (focus)="isVisible = true" (focusout)="isVisible = false;"
            (keyup.enter)="searchByMRN($event)" [placeholder]="'RegistrationPage.searchBar' | translate" />
          <mat-icon matTooltip="{{ 'payerInfo.expand' | translate }}" [matMenuTriggerFor]="masterSearch" *ngIf="!isVisible" class="search-btn">arrow_drop_down</mat-icon>
          <mat-icon matTooltip="{{ 'payerInfo.collapse' | translate }}" *ngIf="isVisible" class="search-btn">arrow_drop_up</mat-icon>
        </div>
        <mat-menu class="menu-master" [overlapTrigger]="false" #masterSearch="matMenu" disabled>
          <div>
            <form #searchForm="ngForm" class="master-search-form" (ngSubmit)="setSearch(searchForm.value,true)"
              data-automation-attribute="form-search">
              <div (click)="$event.stopPropagation()" *ngFor="let search of searchList; let p_index = index"
                class="search-content-row">
                <div *ngFor="let control of search.controls; let c_index = index"
                  class="search-col search-col-{{ control.column }}">

                  <mat-form-field *ngIf="control.type == 'date'" appearance="outline">
                    <mat-label>{{ control.placeholder }}</mat-label>

                    <input matInput [matDatepicker]="picker" placeholder="{{ control.placeholder }}"
                      [(ngModel)]="this[control.name]" value="{{ control.value }}" name="{{ control.name }}" />
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                  </mat-form-field>

                  <div *ngIf="error.isError" class="alert alert-danger">
                    {{ error.errorMessage }}
                  </div>

                  <mat-form-field *ngIf="control.type == 'text'" appearance="outline">
                    <mat-label>{{ control.placeholder }}</mat-label>

                    <input matInput placeholder="{{ control.placeholder }}" [(ngModel)]="this[control.name]"
                      name="{{ control.name }}" value="{{ control.value }}" pattern="[a-zA-Z0-9]+" />
                  </mat-form-field>

                  <mat-form-field *ngIf="control.type == 'number'" appearance="outline">
                    <mat-label>{{ control.placeholder }}</mat-label>

                    <input type="text" matInput placeholder="{{ control.placeholder }}"
                      [(ngModel)]="this[control.name]" name="{{ control.name }}" value="{{ control.value }}"
                      pattern="[a-zA-Z0-9]+" />
                  </mat-form-field>

                  <mat-form-field *ngIf="control.type == 'select'" appearance="outline">
                    <mat-label>{{ control.placeholder }}</mat-label>

                    <mat-select id="{{ control.name }}" placeholder="{{ control.placeholder }}"
                      [(ngModel)]="this[control.name]" name="{{ control.name }}"
                      (selectionChange)="selectOnChange(control.name, $event.value)" value="{{ control.value }}"
                      (focus)="selectOnClick(control, p_index, c_index)">
                      <mat-option>
                        <input
                          id="searchAutoComplete"
                          class="search-select-box"
                          (click)="$event.stopPropagation()"
                          (keyup)="dropdownOnSearch(control, $event)"
                          (keydown.space)="$event.stopPropagation()"
                          type="text"
                          [placeholder]="'RegistrationPage.search' | translate"
                          value="{{ control.searchValue }}"
                        />
                      </mat-option>
                      <div *ngIf="[control.name] == 'unit'">
                        <mat-option *ngFor="let option of control.options" [value]="option.id">
                          {{ option.desc }}
                        </mat-option>
                      </div>
                      <div *ngIf="[control.name] != 'unit'">
                        <mat-option *ngFor="let option of control.options" [value]="option">
                          {{ option.desc }}
                        </mat-option>
                      </div>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>

              <div class="search-content-row">
                <div class="search-col search-col-12 right">
                  <button matTooltip="{{ 'RegistrationPage.searchBar' | translate }}" type="submit"
                    class="btn-master-search" data-automation-attribute="btn-search" mat-button>
                    <mat-icon>search</mat-icon>
                  </button>
                  &nbsp;
                  <button matTooltip="{{ 'payerInfo.reset' | translate }}" type="button" class="btn-master-cancel"
                    mat-button (click)="clearSearch()">
                    <mat-icon>refresh</mat-icon>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </mat-menu>
      </mat-grid-tile>

      <mat-grid-tile [colspan]="1" [rowspan]="1">
          <mat-icon 
            matTooltip="Scan QR Code" 
            class="color-white menuModules mx-2" 
            (click)="openBarcodeScanDialog()"
            *ngIf="patientType=='registered'"
          >
            center_focus_weak
          </mat-icon>
      </mat-grid-tile>

      <mat-grid-tile [colspan]="1" [rowspan]="1" class="header-grid-tileClose">
        <button  matTooltip="{{ 'AddInternalNotes.close' | translate }}" (click)="closeModal()"
         mat-mini-fab class="btnRed" type="button"
          data-automation-attribute="button-cancel-dialog">
          <mat-icon>close</mat-icon>
        </button>
      </mat-grid-tile>
    </mat-grid-list>
  </div>

  <div class="schedule-tab-content">
    <div class="flex">
      <div class="schedule-section section-1">
        <div class="date-next-black2">

          <span class="txtSuper patient-name-label" (click)="picker.open()" style="cursor: pointer">
            <mat-form-field style="width:1px;visibility:hidden;">
              <input matInput [matDatepicker]="picker" />
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
            {{formattedSelectedDate}}
          </span>

        </div>
        <!-- <div class="div-contatiner-dates overflowAuto">
          <div
            [ngClass]="(slot.selected)?'date-next active':(slot.past)?'date-next-black':(slot.blocked)?'date-next-blue':'date-next activ'"
            *ngFor="let slot of dilogData.daySlot" (click)="slectedSlot(slot)" style="cursor: pointer">
            <ng-container>
              {{slot.start | date:'shortTime'}} -{{slot.end |
              date:'shortTime'}}</ng-container>
          </div>
        </div> -->
        <div class="div-contatiner-dates overflowAuto">
          <ng-container *ngFor="let slot of dilogData.daySlot">
            <div
              *ngIf="!slot.past"
              [ngClass]="(slot.selected) ? 'date-next active' : (slot.blocked) ? 'date-next-blue' : (slot.booked)?'slot-booked':
              (slot.available)?'date-next active':'date-next'"
              (click)="slectedSlot(slot)" 
              style="cursor: pointer">
              <ng-container>
                {{ slot.start | date: 'shortTime' }} - {{ slot.end | date: 'shortTime' }}
              </ng-container>
            </div>
          </ng-container>
        </div>
      </div>

      <div class="schedule-section section-4">
        <div class="divfilter"></div>
        <app-patient-search 
        class="mb-10" 
        [search]="searchCriteria" 
        [list]="patientList" 
          [refreshTime]="refreshTime" 
          [hideAfter]="hidePatientSearch" 
          (onActionClick)="patientOnSelect($event)"></app-patient-search>
        <div class="modal-body bodyCreatePasscode" data-automation-attribute="div-modal-body">
          <div class="patient-detail fixed-height">
            <div class="flex">
              <div class="col-8">
                <div *ngIf="patientInfoDisplay" style="display: flex; align-items: center; width: 100vh;">
                  <img [style.width]="'30px'" [src]="patientImage ? patientImage : './assets/images/user.png'" />&nbsp;
                  <label class="patient-name-label" style="margin: 0; padding: 0; line-height: normal; display: flex; align-items: center;"> {{ patientInfoDisplay }}</label>
                  <img
                  class="user-img"
                  [src]="
                    isVip ? './assets/images/email-icons/vip-icon.png' : null
                  "
                  *ngIf="isVip"
                  style="height: 25px;object-position: left;margin-left: 10px;"
                />
                <img class="user-img" [src]="isNoteVisible ? './assets/images/chat-alert-light.png':null" [matTooltip]="isNoteVisible"
                  *ngIf="isNoteVisible" style="height: 28px;" />
                </div>
                <div *ngIf="!patientInfoDisplay">
                  <label class="patient-name-label">{{ "RegistrationPage.noPatient" | translate }}</label>
                </div>
              </div>
              <div class="col-4 right">
              </div>
            </div>
          </div>
        </div>

        <div class="modal-body bodyCreatePasscode" data-automation-attribute="div-modal-body">

          <div class="example-container patientListOnPopup" *ngIf="resultFound">

            <div class="search-result" *ngIf="recordsLength=='0'">
              Record Found ({{ recordsLength }})
            </div>
            <div class="patient-table" (scroll)="onTableScroll($event)">
            <table mat-table #table [dataSource]="dataSource" class="dataSourceTable mt-10"
              data-automation-attribute="table-patient-details">

              <ng-container matColumnDef="photo">
                <th mat-header-cell *matHeaderCellDef class="headerPhoto">
                  {{ "AppointmentPage.photo" | translate }}
                </th>
                <td mat-cell *matCellDef="let element; let i = index" class="headerPhoto">
                  <mat-radio-button value="1" (click)="radioClicked1(element); $event.stopPropagation()"
                    data-automation-attribute="radio-record">

                  </mat-radio-button>
                </td>
              </ng-container>
              <ng-container matColumnDef="MRN">
                <th mat-header-cell *matHeaderCellDef class="headerMRN">{{ "AppointmentPage.mrn" | translate }}</th>
                <td mat-cell *matCellDef="let element" class="headerMRN">
                  {{ element.mrn }}
                </td>
              </ng-container>
              <ng-container matColumnDef="idtype">
                <th mat-header-cell *matHeaderCellDef class="headerNRIC">
                  {{ "AppointmentPage.idType" | translate }}
                </th>
                <td mat-cell *matCellDef="let element" class="headerNRIC">
                  {{ element.primaryIdentifier?element.primaryIdentifier.display:"" }}
                </td>
              </ng-container>

              <ng-container matColumnDef="idnumber">
                <th mat-header-cell *matHeaderCellDef class="headerID">
                  {{ "AppointmentPage.docNo" | translate }}
                </th>
                <td mat-cell *matCellDef="let element" class="headerID">
                  {{ element.primaryIdentifier?element.primaryIdentifier.value:"" }}
                </td>
              </ng-container>

              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef class="headerName">
                  {{ "AppointmentPage.name" | translate }}
                </th>
                <td mat-cell *matCellDef="let element" class="headerName">
                  {{ element.name }}
                  <img
            class="user-img"
            [src]="
              element.vip ? './assets/images/email-icons/vip-icon.png' : null
            "
            *ngIf="element.vip"
            style="height: 20px;margin-bottom: 5px;object-position:left;margin-left: 5px;"
          />

                </td>
              </ng-container>

              <ng-container matColumnDef="gender">
                <th mat-header-cell *matHeaderCellDef class="headerGender">
                  {{ "AppointmentPage.gender" | translate }}
                </th>
                <td mat-cell *matCellDef="let element" class="headerGender">
                  {{ element.gender?element.gender.display:"" }}
                </td>
              </ng-container>

              <ng-container matColumnDef="contact">
                <th mat-header-cell *matHeaderCellDef class="headerContact">
                  {{ "AppointmentPage.phone" | translate }}
                </th>
                <td mat-cell *matCellDef="let element" class="headerContact">
                  {{ element.mobileNumber ?element.mobileNumber.mobileNumber:"" }}
                </td>
              </ng-container>
              <ng-container matColumnDef="dob">
                <th mat-header-cell *matHeaderCellDef class="headerDate">
                  {{ "AppointmentPage.dob" | translate }}
                </th>
                <td mat-cell *matCellDef="let element" class="headerDate">
                  {{ element.birthDate | date }}
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumns sticky: true" class="tableHeader"
                data-automation-attribute="header-patient-details"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns" class="tableRow"
                data-automation-attribute="row-patient-details"></tr>
            </table>
          </div>
        </div>
        
          <div class="selected-date">
            <div class="app-div-against">
              {{ "AppointmentPage.against" | translate }}: <b>{{dilogData.aptmentTypeDesc.desc}}</b>
            </div>
            <div class="app-div-doctor" *ngIf="!dilogData.isQuickSearch">
              {{ "AppointmentPage.doctorname" | translate }}: <b>{{dilogData.doctor.name}}</b>
            </div>
            <div class="app-div-doctor" *ngIf="dilogData.isQuickSearch">
              {{ "AppointmentPage.doctorname" | translate }}: <b>{{dilogData.doctor.desc}}</b>
            </div>
            <div class="app-div">
              {{ "AppointmentPage.date" | translate }}: <b>{{formattedSelectedDate}}</b>
            </div>
            <!-- <div class="app-div-time" *ngIf="dilogData.isQuickSearch">
              {{ "AppointmentPage.appointmentTime" | translate }}: <b
                >{{selectedSlots.start}} -{{selectedSlots.end
                }}</b
              >
            </div> -->
            <div class="app-div-time">
              {{ "AppointmentPage.appointmentTime" | translate }}: <b>{{selectedSlots.start | date:'shortTime'}}
                -{{selectedSlots.end
                | date:'shortTime'}}</b>
            </div>

          </div>

          <div class="top-div-lg" [style.height]="patientData ? '300px' : '460px'" style="overflow: auto;">
            <div class="app-form">
              <form [formGroup]="appointmentForm" #patientRegForm="ngForm">

                <div class="d-flex">
                  <div class="displayInline"> 
                    <img class="user-img" src="assets/images/noavatar.png" alt="Patient" title="Patient"
                      *ngIf="!imageUser" data-automation-attribute="imgDefaultUser" />
                    <img class="user-img" [src]="imageUser" alt="User" title="Patient" *ngIf="imageUser" />
                    <div class="middle" (click)="selectFile()"  *ngIf="patientType!=='registered'">
                      <div class="text">{{ "EncounterListPage.upload" | translate
                        }}</div>
                    </div>
                    <input type="file" class="hide" id="fileAttachment" multiple="multiple" accept="application/Image"
                      (change)="handleFileSelect($event)" />
                  </div>
                  <div class="first-two-grid">
                    <mat-grid-list cols="12" rowHeight="55px">
                      <!-- [defaultValue]="selectedPatient?selectedPatient.identifierType:''" -->
                      <mat-grid-tile [colspan]="4">
                        <!-- <app-master-form-field [isRequired]="true" [label]="'RegistrationPage.primaryID' | translate"
                          [masterName]="masterAPI.IDENTIFICATION_TYPE_MASTER" [formControlName]="'IdType'"
                          [parentForm]="appointmentForm" [defaultValue]="primaryValue"
                          (itemSelected)="primaryIdentificationOnChange($event ,true)"
                          [isSubmitted]="patientRegForm.submitted">
                        </app-master-form-field> -->
                        <mat-form-field appearance="outline" class="full-width">
                          <mat-label>{{ "RegistrationPage.primaryID" | translate }}</mat-label>
                          <mat-select [(ngModel)]="primaryValue" [formControlName]="'IdType'" required
                          (selectionChange)="primaryIdentificationOnChange($event.value ,true)">
                            <mat-option>
                              <ngx-mat-select-search
                                [formControl]="primaryIdSearch"
                                [placeholderLabel]="'RegistrationPage.search' | translate"
                              ></ngx-mat-select-search>
                            </mat-option>
                            <mat-option *ngFor="let data of primaryIdList" [value]="data.code">
                              {{ data.desc }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </mat-grid-tile>

                      <mat-grid-tile [colspan]="4">
                        <mat-form-field appearance="outline" class="full-width">
                          <mat-label>{{ "RegistrationPage.primaryDocNo" | translate}} </mat-label>
                          <input matInput formControlName="IdNumber" 
                          [maxlength]="maxIdentificationLength"
                           [minlength]="minIdentificationLength"
                            [placeholder]="'RegistrationPage.primaryDocNo' | translate"
                            (keyup)="primaryNumberOnKeyUp($event.target.value)"
                            (focusout)="idFocusOut($event.target.value)" [required]="true" /></mat-form-field>
                      </mat-grid-tile>

                      <mat-grid-tile [colspan]="4" *ngIf="showExpirDatePicker">
                        <mat-form-field appearance="outline" class="full-width">
                          <mat-label>{{ "RegistrationPage.expiryDate" | translate}}</mat-label>
                          <!-- <input matInput formControlName="idExpiry" [matDatepicker]="picker21"
                            [placeholder]="'RegistrationPage.expiryDate' | translate" [min]="date"   [max]="maxExpiry" [required]="true" /> -->
                            <input
                             matInput
                             formControlName="idExpiry"
                             [matDatepicker]="picker21"
                             [placeholder]="'RegistrationPage.expiryDate' | translate"
                             [min]="date"
                             [max]="maxExpiry">
                          <mat-datepicker-toggle matSuffix [for]="picker21"></mat-datepicker-toggle>
                          <mat-datepicker #picker21></mat-datepicker>
                        </mat-form-field>
                      </mat-grid-tile>
                    </mat-grid-list>

                    <!-- patient name in two language-->
                    <mat-grid-list *ngIf="!ispatientNameLtwo" cols="12" rowHeight="55px">
                      <mat-grid-tile [colspan]="4">
                        <app-master-form-field [isRequired]="true" [label]="'RegistrationPage.prefix' | translate"
                          [masterName]="masterAPI.PREFIX_MASTER" [formControlName]="'Title'"
                          [defaultValue]="prefixValue" [parentForm]="appointmentForm" (itemSelected)="getGender($event)"
                          (autoLoadCompleted)="getGender($event)" [isSubmitted]="patientRegForm.submitted">
                        </app-master-form-field>
                      </mat-grid-tile>
                      <mat-grid-tile [colspan]="4">
                        <mat-form-field appearance="outline" class="full-width">
                          <mat-label>{{ "RegistrationPage.name" | translate}} </mat-label>
                          <input matInput oninput="this.value = this.value.toUpperCase()" formControlName="FullName"
                            [required]="!ispatientNameLtwo" [placeholder]="'RegistrationPage.name' | translate" maxlength="100"
                            pattern="([a-zA-Z\u0E00-\u0E7F,./@#\s\-%_]+)" />
                        </mat-form-field>
                      </mat-grid-tile>
                      <mat-grid-tile [colspan]="4">
                        <app-master-form-field [isRequired]="true" [label]="'RegistrationPage.gender' | translate"
                          [masterName]="masterAPI.GENDER_MASTER" [formControlName]="'Gender'"
                          [defaultValue]="genderValue" [parentForm]="appointmentForm"
                          [isSubmitted]="patientRegForm.submitted">
                        </app-master-form-field>
                      </mat-grid-tile>
                    </mat-grid-list>
                    <ng-container *ngIf="ispatientNameLtwo">
                      <mat-grid-list cols="11" rowHeight="55px" class="no-gap-grid-list">
                        <mat-grid-tile [colspan]="2">
                          <app-master-form-field [isRequired]="true" [label]="'RegistrationPage.prefix' | translate"
                            [masterName]="masterAPI.PREFIX_MASTER" [formControlName]="'Title'" [defaultValue]="prefixValue"
                            [parentForm]="appointmentForm" (itemSelected)="getGender($event)" (autoLoadCompleted)="getGender($event)"
                            [isSubmitted]="patientRegForm.submitted">
                          </app-master-form-field>
                        </mat-grid-tile>
                    
                        <mat-grid-tile [colspan]="3">
                          <mat-form-field appearance="outline" class="full-width">
                            <mat-label>{{"AppointmentPage.firstNameTh" | translate}}</mat-label>
                            <input matInput formControlName="mfirstName" oninput="this.value = this.value.toUpperCase()" maxlength="100"
                             [required]="ispatientNameLtwo"  />
                          </mat-form-field>
                        </mat-grid-tile>
                    
                        <mat-grid-tile [colspan]="3">
                          <mat-form-field appearance="outline" class="full-width">
                            <mat-label>{{"AppointmentPage.middleNameTh" | translate}}</mat-label>
                            <input matInput formControlName="mmiddleName" oninput="this.value = this.value.toUpperCase()" maxlength="100"
                             />
                          </mat-form-field>
                        </mat-grid-tile>
                    
                        <mat-grid-tile [colspan]="3">
                          <mat-form-field appearance="outline" class="full-width">
                            <mat-label>{{"AppointmentPage.lastNameTh" | translate}}</mat-label>
                            <input matInput formControlName="mlastName" oninput="this.value = this.value.toUpperCase()" maxlength="100"
                             [required]="ispatientNameLtwo"  />
                          </mat-form-field>
                        </mat-grid-tile>
                      </mat-grid-list>

                      <!-- patient name in english -->
                      <mat-grid-list cols="11" rowHeight="55px" class="no-gap-grid-list">
                        <mat-grid-tile [colspan]="2"></mat-grid-tile>
                        <mat-grid-tile [colspan]="3">
                          <mat-form-field appearance="outline" class="full-width">
                            <mat-label>{{"AppointmentPage.firstNameEn" | translate}}</mat-label>
                            <input matInput formControlName="firstName" oninput="this.value = this.value.toUpperCase()"
                             maxlength="100"/>
                          </mat-form-field>
                        </mat-grid-tile>
                      
                        <mat-grid-tile [colspan]="3">
                          <mat-form-field appearance="outline" class="full-width">
                            <mat-label>{{"AppointmentPage.middleNameEn" | translate}}</mat-label>
                            <input matInput formControlName="middleName" oninput="this.value = this.value.toUpperCase()" maxlength="100"
                               />
                          </mat-form-field>
                        </mat-grid-tile>
                      
                        <mat-grid-tile [colspan]="3">
                          <mat-form-field appearance="outline" class="full-width">
                            <mat-label>{{"AppointmentPage.lastNameEn" | translate}}</mat-label>
                            <input matInput formControlName="lastName" oninput="this.value = this.value.toUpperCase()"
                               maxlength="100"  />
                          </mat-form-field>
                        </mat-grid-tile>
                      
                      </mat-grid-list>
                    
                    </ng-container>
                  </div>
                </div>
                <mat-grid-list cols="12" rowHeight="55px">
                  <mat-grid-tile [colspan]="2" *ngIf="ispatientNameLtwo">
                    <app-master-form-field [isRequired]="true" [label]="'RegistrationPage.gender' | translate"
                      [masterName]="masterAPI.GENDER_MASTER" [formControlName]="'Gender'" [defaultValue]="genderValue"
                      [parentForm]="appointmentForm" [isSubmitted]="patientRegForm.submitted">
                    </app-master-form-field>
                  </mat-grid-tile>
                  <mat-grid-tile [colspan]="ispatientNameLtwo ? 2 : 3">
                    <mat-form-field appearance="outline" class="full-width">
                      <mat-label>{{ "RegistrationPage.dobForm" | translate}}</mat-label>
                      <input matInput formControlName="DOB" [matDatepicker]="picker20"
                        [placeholder]="'inventory.chooseaDate' | translate" [min]="mindate" [max]="date"
                        [required]="true" />
                      <mat-datepicker-toggle matSuffix [for]="picker20"></mat-datepicker-toggle>
                      <mat-datepicker #picker20></mat-datepicker>
                    </mat-form-field>
                  </mat-grid-tile>
                   <mat-grid-tile [colspan]="ispatientNameLtwo ? 2 : 3">
                    <mat-checkbox class="margin" formControlName="realdob">
                      {{ "RegistrationPage.realdob" | translate }}
                    </mat-checkbox>

                  </mat-grid-tile>
                  <mat-grid-tile [colspan]="ispatientNameLtwo ? 3 : 3">
                      <div class="patient-age">
                    <div class="year">
                        <input matInput attr.data-automation-attribute="txtpatientageYears"
                          [value]="patientAge?.years"
                          (input)="calculateDob($event.target.value,patientAge?.months, patientAge?.days)"
                        />
                        <span class="unit">Y</span>
                      </div>
                      <div class="months">
                        <input matInput attr.data-automation-attribute="txtpatientageMonths"
                          [value]="patientAge?.months"
                          (input)="calculateDob(patientAge?.years, $event.target.value, patientAge?.days)" 
                          />
                          <span class="unit">M</span>
                      </div>
                      <div class="day">
                        <input matInput [value]="patientAge?.days" (input)="calculateDob(patientAge?.years, patientAge?.months, $event.target.value)"/>
                        <span class="unit">D</span>
                      </div>
                    </div>
                  </mat-grid-tile>
                  <mat-grid-tile [colspan]="3">
                    <app-master-form-field [label]="'RegistrationPage.patientCategory' | translate"
                      [masterName]="masterAPI.PATIENT_CATEGORY_MASTER" [formControlName]="'patientCategory'"
                      [defaultValue]="patientCategoryValue" [parentForm]="appointmentForm" [isSubmitted]="patientRegForm.submitted">
                    </app-master-form-field>
                  </mat-grid-tile>
                  </mat-grid-list>
                  <mat-grid-list cols="9" rowHeight="55px">
                  <mat-grid-tile [colspan]="3">
                  <mat-form-field appearance="outline" class="full-width" >
                <mat-label>
                  {{ "AppointmentPage.appointmenttype" | translate }}
                </mat-label>
                <mat-select [formControl]="visitType" 
                  [placeholder]="'AppointmentPage.appointmenttype' | translate"
                  (selectionChange)="appointmentTypeChange($event.value)"
                   data-automation-attribute="select-appointment-type"
                  #appointmentTypeSelect>
                  <mat-option>
                    <ngx-mat-select-search [formControl]="appointmentTypeDFltrCtrl" class="full-width" ngDefaultControl
                      [placeholderLabel]="'RegistrationPage.search' | translate"></ngx-mat-select-search>
                  </mat-option>
                  <mat-option *ngFor="let option of filteredappointmentType | async" [value]="option.code">
                    {{ option.desc }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              </mat-grid-tile>
              <mat-grid-tile [colspan]="3">
              <mat-form-field  appearance="outline" class="full-width">
                <mat-label>{{
                  "AppointmentPage.consultationtype" | translate
                  }}</mat-label>
                <mat-select [formControl]="teleConsultCtrl" [disabled]="isConsultationVisible"
                  >
                  <mat-option>
                    <ngx-mat-select-search [formControl]="teleFilterCtrl" class="full-width" ngDefaultControl
                      [placeholderLabel]="'RegistrationPage.search' | translate"></ngx-mat-select-search>
                  </mat-option>
                  <mat-option *ngFor="let option of filteredTelecom | async" [value]="option.code">
                    {{ option.desc }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              </mat-grid-tile>
              <mat-grid-tile [colspan]="3">
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>
                  {{ "AppointmentPage.specialty" | translate }}
                </mat-label>
                <mat-select [formControl]="deptCtrl" 
                  [placeholder]="'AppointmentPage.doctordepartment' | translate"
                
                  data-automation-attribute="select-appointment-type" #deptTypeSelect>
                  <mat-option>
                    <ngx-mat-select-search [formControl]="deptFilterCtrl" class="full-width" ngDefaultControl
                      [placeholderLabel]="'RegistrationPage.search' | translate"></ngx-mat-select-search>
                  </mat-option>
                  <mat-option *ngFor="let option of filteredDepts | async" [value]="option.code">
                    {{ option.desc }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              </mat-grid-tile>
                </mat-grid-list>

                <mat-grid-list cols="12" rowHeight="55px">
                  <!-- <mat-grid-tile [colspan]="3">
                    <app-master-form-field [label]="'RegistrationPage.patientCategory' | translate"
                      [masterName]="masterAPI.PATIENT_CATEGORY_MASTER" [formControlName]="'patientCategory'"
                      [defaultValue]="patientCategoryValue" [parentForm]="appointmentForm" [isSubmitted]="patientRegForm.submitted">
                    </app-master-form-field>
                  </mat-grid-tile> -->
                  <mat-grid-tile [colspan]="3">
                    <app-master-form-field [isRequired]="true" [label]="'EncounterPage.countryCode' | translate"
                      [masterName]="masterAPI.COUNTRY_CODE_MASTER" [formControlName]="'countryCodemobile'"
                      [defaultValue]="mobileCodeValue" [parentForm]="appointmentForm"
                      [isSubmitted]="patientRegForm.submitted" 
                      (itemSelected)="setPatternToMobileNumber($event)">
                    </app-master-form-field>
                  </mat-grid-tile>
                  <mat-grid-tile [colspan]="3">
                    <mat-form-field appearance="outline" class="full-width">
                      <mat-label>{{ "RegistrationPage.handphoneNo" | translate}}</mat-label>
                      <input type="tel" [required]="true" formControlName="HandPhoneNumber" matInput
                      oninput="this.value=this.value.replace(/[^0-9/:]/g,'');"
                        [placeholder]="'RegistrationPage.handphoneNo' | translate" [minlength]="mobileNoMin" [maxlength]="mobileNoMax"
                       />
                    </mat-form-field>
                  </mat-grid-tile>
                  <mat-grid-tile [colspan]="3">
                    <mat-form-field appearance="outline" class="full-width">
                      <mat-label>{{ "RegistrationPage.officeContact" | translate}}</mat-label>
                      <input type="tel"
                        formControlName="OffciePhoneNumber" matInput maxlength="15"
                        [placeholder]="'RegistrationPage.officeContact' | translate"
                        [required]="FormRequiredFelds.officeRequired" [pattern]="'[0-9+-]*'" />
                    </mat-form-field>
                  </mat-grid-tile>
                  <mat-grid-tile [colspan]="3">
                    <mat-form-field appearance="outline" class="full-width">
                      <mat-label>{{ "RegistrationPage.localContact" | translate}}</mat-label>
                      <input type="tel" 
                        formControlName="HomePhoneNumber" matInput
                        [placeholder]="'RegistrationPage.localContact' | translate"  maxlength="15"
                        [required]="FormRequiredFelds.homeReqired" [pattern]="'[0-9+-]*'" />
                    </mat-form-field>
                  </mat-grid-tile>
                </mat-grid-list>
                <mat-grid-list cols="12" rowHeight="55px">
                  <mat-grid-tile [colspan]="9">
                    <mat-form-field class="full-width" appearance="outline">
                      <mat-label>{{
                        "RegistrationPage.permanentAddress" | translate
                        }}</mat-label>
                      <input matInput formControlName="addressPrimary" maxlength="100"
                        [placeholder]="'RegistrationPage.permanentAddress' | translate"
                        attr.data-automation-attribute="txtAddress" pattern="^[\s\S]+$" />
                    </mat-form-field>
                  </mat-grid-tile>
                  <mat-grid-tile [colspan]="3">
                    <mat-form-field appearance="outline" class="full-width">
                      <mat-label>{{ "RegistrationPage.emailID" | translate}}</mat-label>
                      <input matInput type="email" formControlName="Email"
                        [placeholder]="'RegistrationPage.emailID' | translate"
                        [required]="FormRequiredFelds.emailRequired" />
                  </mat-form-field>
                  </mat-grid-tile>
                </mat-grid-list>
                <mat-grid-list cols="15" rowHeight="55px">
                  <mat-grid-tile [colspan]="3">
                    <app-master-form-field [isRequired]="false" [label]="'RegistrationPage.country' | translate"
                      [masterName]="masterAPI.COUNTRY_MASTER" [formControlName]="'countryPrimary'"
                      [parentForm]="appointmentForm" [defaultValue]="countryValue"
                      (itemSelected)="getStatePrimaryList($event,false)" [isSubmitted]="patientRegForm.submitted">
                    </app-master-form-field>
                  </mat-grid-tile>
                  <mat-grid-tile [colspan]="3">
                    <app-master-form-field [isRequired]="false" [label]="'RegistrationPage.state' | translate"
                      [masterName]="masterAPI.STATE_MASTER_QUERY" [formControlName]="'statePrimary'"
                      [parentForm]="appointmentForm" [params]="CountryCode" [defaultValue]="stateValue"
                      (itemSelected)="getCityPrimaryList($event)" [isSubmitted]="patientRegForm.submitted">
                    </app-master-form-field>
                  </mat-grid-tile>
                  <mat-grid-tile [colspan]="3">
                    <app-master-form-field [isRequired]="false" [label]="'RegistrationPage.city' | translate"
                      [masterName]="masterAPI.CITY_MASTER_QUERY" [formControlName]="'cityPrimary'"
                      [defaultValue]="cityValue" [parentForm]="appointmentForm" [params]="StateCode"
                      (itemSelected)="getSubDistrictPrimaryList($event)" [isSubmitted]="patientRegForm.submitted">
                    </app-master-form-field>
                  </mat-grid-tile>
                  <mat-grid-tile [colspan]="3">
                    <app-master-form-field [isRequired]="false" [label]="'RegistrationPage.subDistrict' | translate"
                      [masterName]="masterAPI.DIST_MASTER_QUERY" [formControlName]="'subDistrictPrimary'"
                      [defaultValue]="districtValue" [parentForm]="appointmentForm" [params]="CityCode"
                      (itemSelected)="primaryDistrictSelected($event)"
                      [isSubmitted]="patientRegForm.submitted">
                    </app-master-form-field>

                  </mat-grid-tile>
                  <mat-grid-tile [colspan]="3">
                    <mat-form-field class="full-width" appearance="outline">
                      <mat-label>{{
                        "RegistrationPage.zipcode" | translate
                        }}</mat-label>
                      <input matInput type="text" formControlName="pincodePrimary" numberOnly maxlength="10"
                        class="example-right-align" [placeholder]="'RegistrationPage.zipcode' | translate"
                        attr.data-automation-attribute="txtPincode"
                        (focusout)="getAddressByPostCode($event.target.value)" />
                    </mat-form-field>
                    <mat-checkbox
                      [(ngModel)]="isGetAddress"
                      [ngModelOptions]="{ standalone: true }"
                      (change)="searchByPostCode($event)"
                      >{{ "RegistrationPage.search" | translate }}</mat-checkbox>
                  </mat-grid-tile>
                </mat-grid-list>

                <mat-grid-list cols="12" rowHeight="68px">
                  <mat-grid-tile [colspan]="isHsc ? 6 : 8">
                    <mat-form-field appearance="outline" class="full-width">
                      <mat-label>{{ "AppointmentPage.remarks" | translate}} </mat-label>
                      <textarea matInput formControlName="Remarks"  maxlength="1000"></textarea>
                    </mat-form-field>
                  </mat-grid-tile>
                  <mat-grid-tile [colspan]="isHsc ? 3 : 4">
                   <app-master-form-field [label]="'EncounterPage.priority' | translate"
                      [masterName]="masterAPI.APPOINMENT_PRIORITY_LIST" [formControlName]="'priority'"
                      [defaultValue]="priorityValue" [parentForm]="appointmentForm"
                      [isSubmitted]="patientRegForm.submitted">
                    </app-master-form-field>
                  </mat-grid-tile>
                  <mat-grid-tile [colspan]="3" *ngIf="isHsc">
                    <mat-form-field class="full-width" appearance="outline">
                      <mat-label> Health Packages</mat-label>
                      <mat-select [(ngModel)]="healthPackage" required multiple placeholder="Select"
                        (selectionChange)="pakageChecked($event.value)"
                        data-automation-attribute="select-encounter-type">
                        <mat-option *ngFor="let package of healthPackageList" [value]="package">
                          {{ package.desc }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </mat-grid-tile>
                </mat-grid-list>
                <mat-grid-list cols="12" rowHeight="68px">
                   <mat-grid-tile [colspan]="7">
                    <mat-form-field appearance="outline" class="full-width">
                      <mat-label>{{ "AppointmentPage.specialInstruction" | translate}} </mat-label>
                      <textarea matInput formControlName="specialInstruction"  maxlength="1000"></textarea>
                    </mat-form-field>
                  </mat-grid-tile>
                  <mat-grid-tile [colspan]="5"  *ngIf="!isNeedTranslator"></mat-grid-tile>
                  <ng-container *ngIf="isNeedTranslator">
                  <mat-grid-tile [colspan]="2">
                    <mat-checkbox formControlName="needTranslator">
                      {{ "RegistrationPage.needTranslator" | translate }}
                    </mat-checkbox>
                  </mat-grid-tile>
                 
                  <mat-grid-tile [colspan]="3" *ngIf="appointmentForm.get('needTranslator')?.value">
                    <mat-form-field class="full-width" appearance="outline">
                      <mat-label>
                        {{ "RegistrationPage.translatorNote" | translate }}
                      </mat-label>
                      <input matInput formControlName="translatorLanguage" maxlength="250"
                        [placeholder]="'RegistrationPage.translatorNote' | translate" />
                    </mat-form-field>
                  </mat-grid-tile>
                  </ng-container>
                  </mat-grid-list>
                  <div class="horizontal-container">
                    <div *ngFor="let data of specialReqList; let i=index" class="horizontal-item">
                      <label>
                          <input type="checkbox" [(ngModel)]="specialReq" [value]="data" (change)="onCheckboxChange($event, data, false)" />
                          {{data.desc}}
                        </label>
                      </div>
                    </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer" data-automation-attribute="div-modal-footer">

      <div class="no-patients" *ngIf="saveAction">
        Please wait a moment
      </div>
      <div *ngIf="this.dilogData.waitingPatient">
        <div class="selected-date" style="border-radius: 10px;margin-right: 200px;" > 
          <div style="padding: 5px;">
         <b>Date Preference:</b> &nbsp;&nbsp; {{datePreferanceDiaplay}}, &nbsp;&nbsp;<b>Time Preference:</b>&nbsp;&nbsp; {{dilogData.waitingPatient?.timePrefFormTime}} To {{dilogData.waitingPatient?.timePrefToTime}}
        </div>
      </div>
            </div>
      <div *ngIf="this.dilogData.reScheduleData">
        <mat-form-field appearance="outline">
          <mat-label>{{ "billing.reason" | translate }}</mat-label>
          <mat-select [(ngModel)]="reason" name="first" required>
            <mat-option>
              <ngx-mat-select-search
                [formControl]="reasonSearch"
                [placeholderLabel]="'RegistrationPage.search' | translate"
              ></ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let reasonCode of reasonList" [value]="reasonCode.code">
              {{ reasonCode.desc }}
            </mat-option>
          </mat-select>
        </mat-form-field>

      </div>
      <div *ngIf="this.dilogData.reScheduleData">
        <mat-form-field appearance="outline">
          <mat-label>{{ "AppointmentListPage.remarks" | translate }} </mat-label>
          <textarea matInput [(ngModel)]="reschRemarks"></textarea>
        </mat-form-field>
      </div>

      <div mat-dialog-actions>
        <button matTooltip="{{ 'payerInfo.save' | translate }}" class="btnCyan" mat-mini-fab
          data-automation-attribute="btn-save" (click)="onSubmit(appointmentForm)" type="button" [disabled]="saveAction"
          form="ngForm">
          <mat-icon>sim_card</mat-icon>
        </button>
        <button matTooltip="{{ 'payerInfo.clear' | translate }}" (click)="clearForm()" class="btnOrange" mat-mini-fab
          type="button" data-automation-attribute="btn-clear">
          <mat-icon>refresh</mat-icon>
        </button>
      </div>
    </div>
  </div>
</div>